import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-catalogProduct" }
const _hoisted_2 = {
  key: 0,
  class: "c-catalogProduct__loading"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "p-disclaimer" }
const _hoisted_7 = { class: "info__heading" }
const _hoisted_8 = {
  key: 1,
  class: "info__price info__price--empty"
}
const _hoisted_9 = { class: "info__action" }

import { ProductObjectViewModel } from "../../@types/generated/ProductObjectViewModel";
import Labels from "@/vue/components/objects/Labels.vue";
import Favorite from "@/vue/components/commerce/Favorite.vue";
import Rating from "@/vue/components/objects/Rating.vue";
import PriceObject from "../objects/PriceObject.vue";
import CartAddPurchasable from "../objects/CartAddPurchasable.vue";

type Props = {
	product: ProductObjectViewModel | number;
	loading: Boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogProduct',
  props: {
    product: {},
    loading: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.loading || typeof props.product == 'number')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "c-catalogProduct__content",
          href: props.product.url
        }, [
          _createVNode(Labels, {
            class: "label",
            labels: props.product.labels
          }, null, 8, ["labels"]),
          _createVNode(Favorite, {
            class: "favorite",
            id: props.product.id
          }, null, 8, ["id"]),
          _createElementVNode("div", {
            class: _normalizeClass(["image", { 'image--whitespace': props.product.image.whitespace }])
          }, [
            _createElementVNode("img", {
              src: props.product.image.src,
              alt: props.product.image.alt
            }, null, 8, _hoisted_4)
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Rating, {
              class: "info__rating",
              review: props.product.review
            }, null, 8, ["review"]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(props.product.brand.title), 1),
            _createElementVNode("h3", _hoisted_7, _toDisplayString(props.product.title), 1),
            (props.product.stock.status !== 'VOUCHER')
              ? (_openBlock(), _createBlock(PriceObject, {
                  key: 0,
                  class: "info__price",
                  price: props.product.price
                }, null, 8, ["price"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(CartAddPurchasable, {
                class: "button",
                id: props.product.purchasableId,
                stock: props.product.stock,
                variants: props.product.variants
              }, null, 8, ["id", "stock", "variants"])
            ])
          ])
        ], 8, _hoisted_3))
  ]))
}
}

})